import { render, staticRenderFns } from "./PackageManagementForm.vue?vue&type=template&id=5b30e483&scoped=true"
import script from "./PackageManagementForm.vue?vue&type=script&lang=js"
export * from "./PackageManagementForm.vue?vue&type=script&lang=js"
import style0 from "./PackageManagementForm.vue?vue&type=style&index=0&id=5b30e483&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b30e483",
  null
  
)

export default component.exports